import { Component, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, OnInit, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { LayoutService } from './layout.service';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ReservationDetailsComponent } from './reservation-details/reservation-details/reservation-details.component';
import { ButtonValue } from '../shared/dynamicform/models/common-models';
import { buttonTypes, componentName, DEFAULT_LANGUAGE_ID, HeaderStyle } from '../shared/constants/commonenums';
import { TablesLayoutComponent } from './tables-layout/tables-layout.component';
import { GuestDetailsComponent } from './guest-details/guest-details.component';
import { ConfirmationDetailsComponent } from './confirmation-details/confirmation-details.component';
import { Subscription } from 'rxjs';
import { CustomGuestFieldsModel } from '../shared/Models/PartyModels';
import { TranslateService } from '@ngx-translate/core';


// import { StringifyOptions } from 'querystring';
import { Language, LanguageFileName, operationType } from '../shared/Models/WidgetSettingsModels';
import { DataRetentionPolicyComponent } from './data-retention-policy/data-retention-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { urlConfig } from '../shared/constants/url-config';
import { PopupService } from 'src/app/shared/services/popup.service';
import { GuestService } from '../shared/services/guest.service';
import { LocalizeService } from '../shared/services/localize.service';
import { DynamicFormService } from '../shared/dynamicform/service/dynamic-form.service';
import { AppInitializer } from '../app-initializer';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'seat-v2';
  currentRoute: string = ''
  imageUrl: any;
  imgAvailable: boolean;
  currentComponent: any;
  subscriptions: Subscription = new Subscription();
  componentArray = [ReservationDetailsComponent, TablesLayoutComponent, GuestDetailsComponent, ConfirmationDetailsComponent, TermsOfUseComponent , PrivacyPolicyComponent, DataRetentionPolicyComponent]
  //restaurantName: string = '';
  restaurantId: Number;
  currentComponentName = componentName.reservationDetails;
  componentName = componentName;
  errorMessage: string;
  showMessage = false;
  acceptReservation = false;
  outOfServiceMessage: any;
  showFooter = true;
  hideImage = false;
  environment = environment;
  isHeaderDisplayed;
  backgroundImageData: any;

  constructor(public ls: LayoutService, private renderer: Renderer2, private router: Router, private route: ActivatedRoute, private ts: TranslateService,  public ps: PopupService, public gs: GuestService,
    private appIntializer: AppInitializer,
    private localizeService: LocalizeService, private dfs: DynamicFormService,) {
  }

  ngOnInit() {
    this.currentComponent = this.componentArray[componentName.reservationDetails];
    this.ls.curentComponent = ReservationDetailsComponent;
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.routerState.snapshot.url != '/' ? this.router.routerState.snapshot.url.split('/')[1] : '';
      }
    });
    if(!this.gs.selectedLanguageId){
      let language = this.route.snapshot.params?.language || this.route.snapshot.queryParams?.language;
      this.gs.selectedLanguageId = language ? Number(LanguageFileName[language.toLowerCase()]) : (sessionStorage.getItem('languageId') ? +sessionStorage.getItem('languageId') : DEFAULT_LANGUAGE_ID);
      this.gs.selectedLanguageId && sessionStorage.setItem('languageId', this.gs.selectedLanguageId.toString())
    }
    if (this.route.snapshot.params.pageName && this.route.snapshot.params.restaurantName) {
      this.currentComponent = this.componentArray[componentName[this.route.snapshot.params.pageName.toLowerCase()]];
      if (this.currentComponent) {
        this.ls.restaurantWidgetName = this.route.snapshot.params.restaurantName;
        this.subscriptions.add(this.ls.getWidgetSettingsByRestaurantName(this.ls.restaurantWidgetName, this.gs.selectedLanguageId).subscribe(data => {
          if (data) {
            this.setCustomStyles(data.RestaurantUniqueName);
            this.loadBackgroundImage(this.restaurantId);
            this.acceptReservation = data.AcceptsReservations && !data.DisableReservations;
            this.imageUrl = environment.BaseUrl + urlConfig.widgetImageURL + data.RestaurantId;
            if(data?.OperationCurrency ){
              this.ls.OperationCurrency = data.OperationCurrency
            }
           // this.gs.loadLanguageData(null)
            this.ls.restaurantWidgetSettings$.next(data);
            this.ps.restaurantWidgetSettings$.next(data);
            this.loadDataRetentionPolicy();
          }
          else {
            this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
          }
        }));
      }
      else {
        this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
      }
    }
    else if (this.route.snapshot.params.restaurantName) {
      this.ls.restaurantWidgetName = this.route.snapshot.params.restaurantName;
      this.ls.specialMealIdFromURL = this.route.snapshot.params.specialMealIdFromURL;
      this.subscriptions.add(this.ls.getWidgetSettingsByRestaurantName(this.ls.restaurantWidgetName, this.gs.selectedLanguageId).subscribe(data => {
        if (data) {
          this.setCustomStyles(data.RestaurantUniqueName);
          this.loadBackgroundImage(data.RestaurantId);
          //this.gs.loadLanguageData(null)
          this.ls.globalSeatingAreaId = this.route.snapshot.queryParams["section_id"];
          this.loadRestaurantSettings(data);
          this.setLanguage(data);
        }
        else {
          this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
        }
      }));

    }
    else if (this.route.snapshot.params.restaurantToken) {
      this.restaurantId = this.route.snapshot.params.restaurantId;
      this.ls.reservationToken = this.route.snapshot.params.restaurantToken;
      this.ls.operation = this.route.snapshot.params.operation == "edit" ? operationType.edit : this.route.snapshot.params.operation == "cancel" ? operationType.cancel : operationType.create;
      this.ls.language = Number(LanguageFileName[this.route.snapshot.params.language.toLowerCase().toString()]);
      this.ls.byPassValidation = true;
      this.gs.byPassValidation = true;
      this.subscriptions.add(this.ls.getByToken(this.ls.reservationToken).subscribe(reservation => {
        if (reservation) {
          this.restaurantId = reservation.RestaurantId;
          this.subscriptions.add(this.ls.getWidgetSettingsByRestaurantId(this.restaurantId).subscribe(data => {
            if (data) {
              this.setCustomStyles(data.RestaurantUniqueName);
              this.loadBackgroundImage(this.restaurantId);
              this.loadRestaurantSettings(data);
              this.ls.editPartyData$.next(reservation);
              this.setLanguage(data);
            }
            else {
              this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
            }

          }));
        }
        else {
          this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
        }
      }));
    }
    else {
      this.outOfServiceMessage = { message: this.gs.ConfigSettings.commonErrorMessage };
    }
  }

  setCustomStyles(restaurantUniqueName) {
    var head = document.head;
    var link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = this.appIntializer.configSettings.styleURL + `/styles_${restaurantUniqueName}.css`;

    head.appendChild(link);
  }

  setLanguage(data){
    const url = new URL(window.location.href);
    let paramLanguage = this.route.snapshot.params['language']|| url.searchParams.get('language');
    if(paramLanguage){
      paramLanguage = LanguageFileName[Number(LanguageFileName[paramLanguage.toLowerCase()])];
    }else{
      paramLanguage = sessionStorage.getItem('languageId') ? LanguageFileName[sessionStorage.getItem('languageId')] : LanguageFileName[Number(LanguageFileName.english)]
    }
    this.localizeService.setLanguage(paramLanguage, data.PropertyType.toLowerCase(), data.RestaurantUniqueName);
  }

  closeMessage(event) {
    this.gs.setMessageState('', 0);
  }

  ngAfterViewInit() {
    this.subscriptions.add(this.ls.nextButton.subscribe(x => {
      this.currentComponent = this.componentArray[x];
      this.currentComponentName = x;
      this.gs.currentComponentName =x;
    }));
  }

  ngAfterViewChecked() {
    if (this.ls.restaurantWidgetSettings$.value) {
      this.isHeaderDisplayed = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderStyle != HeaderStyle.none;
      this.setbackgroundImage();
      let subHeaderElements = document.querySelectorAll('.layout__content .confirmation-title,.layout__content .page-title');
      subHeaderElements.forEach(data => {
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor);
      });
      let formElements = document.querySelectorAll('.layout__content .default-form-field,.layout__content .reservation-summary,.layout__content .helper-text,.privacy-policy .section-header,.terms-of-use .section-header,.layout__content .mat-form-field, .mat-option,.layout__content .default-sub-header');
      formElements.forEach(data => {
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.BodyTextColor);
      });
      let specialMealElements = document.querySelectorAll('.reservation-details__special-meal-data .default-sub-header,.reservation-details__special-meal-data .reservation-details__special-meal-serves');
      specialMealElements.forEach(data => {
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SMFontColor);
        this.renderer.setStyle(data, 'font-size', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFontSize);
      })
      let inputElements = document.querySelectorAll('.mat-input-element');
      inputElements.forEach(data => {
        this.renderer.setStyle(data, 'caret-color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.BodyTextColor);
      });
      let actionButton = document.querySelectorAll('.layout__content .custom-button__confirm,.cdk-overlay-container .custom-button__confirm, .mat-calendar-body-selected');
      actionButton.forEach(data => {
        this.renderer.setStyle(data, 'background-color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PrimaryButtonBGColor);
        if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PrimaryButtonBGColor == '#ffffff') {
          this.renderer.setStyle(data, 'border-color', "#000000");
        } else {
          this.renderer.setStyle(data, 'border-color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PrimaryButtonBGColor);
        }
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.PrimaryButtonTextColor);
        //  Need to change the styles based on Merchant portal
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonFont);
        this.renderer.setStyle(data, 'font-size', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonFontSize + 'px');
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonStyle == 'Rounded' ? this.renderer.setStyle(data, 'border-radius', 5) : this.renderer.setStyle(data, 'border-radius', 0);
      });
      let btnIcon = document.querySelectorAll('.layout__content .custom-button__cancel,.layout__content .custom-button__cancel .btn-icon');
      btnIcon.forEach(data => {
        this.renderer.setStyle(data, 'background-color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SecondaryButtonBGColor);
        if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SecondaryButtonBGColor == '#ffffff') {
          this.renderer.setStyle(data, 'border-color', "#000000");
        } else {
          this.renderer.setStyle(data, 'border-color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SecondaryButtonBGColor);
        }
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.SecondaryButtonTextColor);
        //  Need to change the styles based on Merchant portal
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonFont);
        this.renderer.setStyle(data, 'font-size', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonFontSize + 'px');
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonStyle == 'Rounded' ? this.renderer.setStyle(data, 'border-radius', 5) : this.renderer.setStyle(data, 'border-radius', 0);
      });

      let timeButtons = document.querySelectorAll('.layout__content .custom-button__option');
      timeButtons.forEach(data => {
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AvailableButtonColor);
        //  Need to change the styles based on Merchant portal
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderFont);
        this.renderer.setStyle(data, 'font-size', '16px');
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ButtonStyle == 'Rounded' ? this.renderer.setStyle(data, 'border-radius', 5) : this.renderer.setStyle(data, 'border-radius', 0);

      });
      let matInputElements = document.querySelectorAll('.mat-form-field.input-with-boundary .mat-form-field-wrapper,.reservation-details__special-meal-data,.dynamic-radio .mat-radio-button');
      matInputElements.forEach(data => {
        this.ls.restaurantWidgetSettings$.value.WidgetCustomization.InputStyle == 'Rounded' ? this.renderer.setStyle(data, 'border-radius', 4) : this.renderer.setStyle(data, 'border-radius', 0);
      })

      let hyperlinkElements = document.querySelectorAll('.default-hyperlink');
      hyperlinkElements.forEach(data => {
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.HyperlinkFont);
      })
      this.showFooter = !(environment.SEAProduction && this.environment.restaurantIds.filter(x => x == this.ls.restaurantWidgetSettings$.value.RestaurantId).length > 0)
      
      let restaurantNameElement = document.querySelectorAll('.layout__property-name');
      restaurantNameElement.forEach(data => {
        this.renderer.setStyle(data, 'font-size', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantNameSize+'px');
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantNameFont);
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantNameTextColor);
      })

      let restaurantAddressElement = document.querySelectorAll('.reservation-address');
      restaurantAddressElement.forEach(data => {
        this.renderer.setStyle(data, 'font-size', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantAddressSize+'px');
        this.renderer.setStyle(data, 'font-family', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantAddressFont);
        this.renderer.setStyle(data, 'color', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.RestaurantAddressTextColor);
      })
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadBackgroundImage(restaurantId) {
    this.subscriptions.add(this.ls.getBackgroundImage(restaurantId).subscribe(response => {
      if (response) {
        this.backgroundImageData = response.Payload;
        this.setbackgroundImage();
      }
    }))
  }

  loadDefaultImage(event) {
    this.hideImage = true;
  }


  loadDataRetentionPolicy() {
    if (this.ls.restaurantWidgetSettings$.value.IsGDPREnabled) {
      this.subscriptions.add(this.ls.GetRestaurantPolicy(this.ls.restaurantWidgetSettings$.value.RestaurantId).subscribe(data => {
        if (data) {
          this.ls.fromclient = this.route.snapshot.queryParams["client"] == "yes" ? true : false;
          this.ls.dataRetentionPolicy$.next(data);
        }
      }));
    }
  }

  setbackgroundImage() {
    let mainContainer = document.getElementsByClassName('main-container');
    if (this.backgroundImageData && mainContainer) {
      this.renderer.setStyle(mainContainer[0], 'background-image', 'url(data:image/png;base64,' + this.backgroundImageData + ')');
      this.renderer.setStyle(mainContainer[0], 'background-repeat', 'no-repeat');
      this.renderer.setStyle(mainContainer[0], 'background-size', 'cover');
      this.renderer.setStyle(mainContainer[0], 'background-position', 'center');
    } else if(this.ls.restaurantWidgetSettings$.value){
      this.renderer.setStyle(mainContainer[0], 'background', this.ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetBackgroundColor);
    }
  }

  loadRestaurantSettings(data) {
    let allowReservations = data.AcceptsReservations && !data.DisableReservations;
    this.acceptReservation = data.WidgetCustomization.AllowNewReservations ? allowReservations && data.AvailableSpecialMeals.length > 0 : allowReservations;
    this.dfs.ValidateGuestPhoneNumber = data.ValidateGuestPhoneNumber;
    if (this.acceptReservation) {
      this.gs.addGoogleTagManager(data.WidgetCustomization.GTMCode);
      this.imageUrl = environment.BaseUrl + urlConfig.widgetImageURL + data.RestaurantId;
      if(data?.OperationCurrency ){
        this.ls.OperationCurrency = data.OperationCurrency
      }
      this.ls.restaurantWidgetSettings$.next(data);
      this.ps.restaurantWidgetSettings$.next(data);

      if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowTableSelection) {
        this.ls.getRestaurantImages(this.ls.restaurantWidgetSettings$.value.RestaurantId);
      }

      this.subscriptions.add(this.ls.GetCustomFields(data.RestaurantId).subscribe(data => {
        this.ls.customGuestFields = data;
      }));

      this.subscriptions.add(this.ls.GetCountries().subscribe(data => {
        this.ls.countriesList = data;
        this.dfs.countriesList = data;
      }))

      if (this.ls.operation == operationType.create) {
        this.loadDataRetentionPolicy();
      }

    }
    else {
      const propertyName= data.PropertyType === this.gs.ConfigSettings.defaultPropertyName? this.gs.ConfigSettings.defaultPropertyName : this.gs.ConfigSettings.generalPropertyName;
      this.ts.get('notAcceptOnlineWebReservation', {propertyName: propertyName, restaurantName: data.RestaurantName, phoneNumber: data.PhoneNumber}).subscribe(result => {
        this.outOfServiceMessage= {message : result, params: {propertyName: propertyName, restaurantName: data.RestaurantName, phoneNumber: data.PhoneNumber}};
      })
    }

  }

}
